/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payouts_And_BillingInputs */

const en_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payouts & Billing`)
};

const es_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagos y Facturación`)
};

const fr_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements et Facturation`)
};

const de_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungen & Abrechnung`)
};

const ja_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払いと請求`)
};

const zh_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提现与账单`)
};

const ar_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدفوعات والفوترة`)
};

const id_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran & Penagihan`)
};

const it_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamenti & Fatturazione`)
};

const ru_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выплаты и биллинг`)
};

const pt_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamentos e Faturamento`)
};

const ko_payouts_and_billing = /** @type {(inputs: Payouts_And_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정산 및 청구`)
};

/**
* | output |
* | --- |
* | "Payouts & Billing" |
*
* @param {Payouts_And_BillingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const payouts_and_billing = /** @type {((inputs?: Payouts_And_BillingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payouts_And_BillingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_payouts_and_billing(inputs)
	if (locale === "es") return es_payouts_and_billing(inputs)
	if (locale === "fr") return fr_payouts_and_billing(inputs)
	if (locale === "de") return de_payouts_and_billing(inputs)
	if (locale === "ja") return ja_payouts_and_billing(inputs)
	if (locale === "zh") return zh_payouts_and_billing(inputs)
	if (locale === "ar") return ar_payouts_and_billing(inputs)
	if (locale === "id") return id_payouts_and_billing(inputs)
	if (locale === "it") return it_payouts_and_billing(inputs)
	if (locale === "ru") return ru_payouts_and_billing(inputs)
	if (locale === "pt") return pt_payouts_and_billing(inputs)
	return ko_payouts_and_billing(inputs)
});